import { IRazonBody, IRazonEdit, IRazonEiminar } from "../../Interfaces/auxiliar/IRazon";
import { Ifilter } from "../../Interfaces/filter";
import { fetchListVerificacion } from "../http-common";

const razon = "Razon";

const ListarRazones = (request: Ifilter) => {
   return fetchListVerificacion.post(`${razon}/Listar`, request);
};

const UpdateRazon = (request: IRazonEdit) => {
   return fetchListVerificacion.put(`${razon}/EditarRazon`, request);
};

const CrearRazon = (request: IRazonBody) => {
   return fetchListVerificacion.post(`${razon}/CrearRazon`, request);
};

const EliminarRazon = (request: IRazonEiminar) => {
   const queryParams = new URLSearchParams(request as any).toString();
   return fetchListVerificacion.delete(`${razon}/EliminarRazon?${queryParams}`);
}

const ComboRazon = (request: Ifilter, controller = new AbortController()) => {
   return fetchListVerificacion.get(`${razon}/Combo`, {
      params: request,
      signal: controller.signal,
   });
};

export const RazonService = {
   ListarRazones, UpdateRazon, CrearRazon, EliminarRazon, ComboRazon
}